import { Pagination } from "@mantine/core";
import { useTableProvider } from "../../provider";

export function TablePaginationComponent() {
  const { totalPage, changePage } = useTableProvider();

  return <Pagination total={totalPage} onChange={changePage} />;
}
